import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = ({ isLoggedIn }) => {
  if (!isLoggedIn) {
    // If user is not logged in, redirect them to the login page
    return <Navigate to="/login" replace />;
  }

  // If user is logged in, render the child routes via the Outlet
  return <Outlet />;
};

export default ProtectedRoute;